import styled from 'styled-components';
import { devices } from '../../../../juristec-ui/core/breakpoints';

export const OnboardingReportContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 .5rem 1rem;
  gap: 1rem;
  min-width: 310px;
  @media ${devices.phoneS} {
    min-width: auto;
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
